import script from "./MaCollectivite.vue?vue&type=script&setup=true&lang=ts"
export * from "./MaCollectivite.vue?vue&type=script&setup=true&lang=ts"

import "./MaCollectivite.vue?vue&type=style&index=0&id=01d1d6ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01d1d6ca"]])

export default __exports__